import React from 'react';
import { LucideIcon } from 'lucide-react';

interface SidebarRailItemProps {
  label: string;
  icon: LucideIcon;
  /** Optional theme-aware image icon — overrides `icon` when present */
  iconImage?: { light: string; dark: string };
  isDark?: boolean;
  isActive?: boolean;
  isCollapsed: boolean;
  onClick: () => void;
  variant?: 'default' | 'danger';
}

const SidebarRailItem: React.FC<SidebarRailItemProps> = ({
  label,
  icon: Icon,
  iconImage,
  isDark,
  isActive = false,
  isCollapsed,
  onClick,
  variant = 'default',
}) => {
  const baseClass =
    variant === 'danger' ? 'cgm-rail-item cgm-rail-item--danger' : 'cgm-rail-item';
  const activeClass = isActive ? 'cgm-rail-item--active' : '';

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${baseClass} ${activeClass}`}
      aria-label={label}
      data-collapsed={isCollapsed || undefined}
      data-label={label}
    >
      <span className="cgm-rail-item-icon">
        {iconImage ? (
          <img
            src={isDark ? iconImage.dark : iconImage.light}
            alt=""
            className="w-5 h-5 object-contain cgm-rail-img-icon"
          />
        ) : (
          <Icon className="w-5 h-5" />
        )}
      </span>
      <span className="cgm-rail-item-label" aria-hidden={isCollapsed}>
        {label}
      </span>
    </button>
  );
};

export default SidebarRailItem;
